import { useQuery } from "@apollo/client";
import { useMemo } from "react";

import { pointSystemDisplayTablesQuery } from "@/components/model/user/_graphql";
import {
  PENALTY_RULES,
  type PenaltyRuleRow,
} from "@/components/model/user/_type";

function mapPenaltyRules(
  rules: { cancelTime: string; penaltyPoint: string }[] | undefined,
): PenaltyRuleRow[] | undefined {
  if (!rules?.length) return undefined;
  return rules.map(({ cancelTime, penaltyPoint }) => ({
    cancelTime,
    penaltyPoint,
  }));
}

type UsePenaltyRulesOptions = {
  /** true のとき GraphQL を呼ばずフォールバック定数のみ返す */
  skip?: boolean;
};

/** pointSystemDisplayTables.penaltyRules を取得し、失敗時は PENALTY_RULES にフォールバック */
export function usePenaltyRules(
  options: UsePenaltyRulesOptions = {},
): PenaltyRuleRow[] {
  const { skip = false } = options;
  const { data, error } = useQuery(pointSystemDisplayTablesQuery, {
    fetchPolicy: "cache-first",
    skip,
  });

  return useMemo(() => {
    if (skip || error) return PENALTY_RULES;
    const fromApi = mapPenaltyRules(
      data?.pointSystemDisplayTables?.penaltyRules,
    );
    return fromApi ?? PENALTY_RULES;
  }, [data, error, skip]);
}
